import React from 'react';
import { Heading4 } from '@latitude/heading';
import { constants } from '@latitude/core';
import Text from '@latitude/text/Text';
import { MARGIN } from '@/utils/constants';
import {
  StyledHeaderSection,
  StyledGrid,
  StyledTextContainer,
  StyledImage
} from './PageHeader.styled';

/**
 *
 * @param heading - main heading text
 * @param subheading - sub text for header
 * @param imageUrl - image url to show for header
 *
 * @returns HowToApplyPageHeader
 */
const HowToApplyPageHeader = ({ heading, subheading, imageUrl }) => {
  return (
    <StyledHeaderSection className="how-to-apply-header">
      <StyledGrid className="how-to-apply-grid">
        <StyledTextContainer className="how-to-apply-text-container">
          <Heading4 marginBottom={MARGIN.M8} color={constants.COLOR.WHITE}>
            {heading}
          </Heading4>
          <Text color={constants.COLOR.WHITE}>{subheading}</Text>
        </StyledTextContainer>
        <StyledImage imageOnly src={imageUrl} alt={heading} />
      </StyledGrid>
    </StyledHeaderSection>
  );
};

export default HowToApplyPageHeader;
